module.exports = __webpack_public_path__ + "static/outside-f7f6a90429e899796047d656d53b0dae.jpeg";